import React from 'react'

export const TabAdderDisplay = React.createContext();